import Repository from './Repository'
import TokenService from '../helpers/token'
const resource = `${Repository.defaults.baseURL}/core-action-log`
export default {
    async detail(params) {
        const response = await Repository.get(`${resource}/list/by-contact`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },

    async listActionLogType(params) {
        const response = await Repository.get(`${resource}/list-action-log-type`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },

    async listServey(params) {
        return await Repository.get(`${Repository.defaults.baseURL}/survey-ldp-pas`, {
            params,
            headers: TokenService.getHeader(),
        })
    },
    async listTypeServey() {
        return await Repository.get(`${Repository.defaults.baseURL}/survey-ldp-pas/type`, {
            headers: TokenService.getHeader(),
        })
    }
}